/*
    暴露接口文件
*/
import user from './user'
import knowledge from './knowledge'
import home from './home'

export default {
    user,
    knowledge,
    home
}